import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MessageComponent} from './components/message/message.component';
import {AngularMaterialModule} from '../angular-material/angular-material.module';
import {TranslateModule} from '@ngx-translate/core';
import {HelpDialogComponent} from './components/help-dialog/help-dialog.component';
import {HelpIconButtonComponent} from './components/help-icon-button/help-icon-button.component';
import {ConfirmDialogComponent} from './components/confirm-dialog/confirm-dialog.component';
import {QuestionDialogComponent} from './components/question-dialog/question-dialog.component';
import {GenericDialogComponent} from './components/generic-dialog/generic-dialog.component';
import {ZoomHelpComponent} from './components/charts-common/zoom-help/zoom-help.component';
import {NewTabButtonComponent} from './components/charts-common/new-tab-button/new-tab-button.component';


@NgModule({
  declarations: [
    MessageComponent,
    HelpDialogComponent,
    HelpIconButtonComponent,
    ConfirmDialogComponent,
    QuestionDialogComponent,
    GenericDialogComponent,
    ZoomHelpComponent,
    NewTabButtonComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    TranslateModule
  ],
  exports: [
    AngularMaterialModule,
    TranslateModule,
    HelpIconButtonComponent,
    ZoomHelpComponent,
    NewTabButtonComponent
  ]
})
export class SharedModule {
}
